<script setup lang="ts">
import {
  BorrowingRequestFormData,
  BorrowingTransactionRequest,
} from '@/types/borrowing.type';
import { TSButton, TSDialogConfirm } from 'tsv2-library';

const visible = defineModel<boolean>('visible', { required: true });

defineProps<{
  data: BorrowingRequestFormData[] | BorrowingTransactionRequest[];
  mode?: 'Confirmation';
}>();

defineEmits<{
  confirm: [];
}>();
</script>
<template>
  <TSDialogConfirm
    v-model:visible="visible"
    :actionable="mode === 'Confirmation'"
    :show-icon="false"
    @confirm="$emit('confirm')"
    confirm-label="Submit"
    data-ts-name="linked-asset-detail"
    header="Linked Asset"
    severity="success"
  >
    <template #body>
      <ul v-if="mode === 'Confirmation'">
        <li
          :key="datum._id"
          v-for="datum in data.filter(
            (dat) => dat.children && dat.children.length,
          )"
        >
          {{ datum.name.nameWithSequence }}
        </li>
      </ul>
      <span v-if="mode === 'Confirmation'">
        The following assets have other assets linked to them:
      </span>
      <div
        :key="datum._id"
        v-for="datum in data.filter(
          (dat) => dat.children && dat.children.length > 0,
        )"
        class="flex flex-col"
      >
        <span>{{ datum.name.nameWithSequence }}:</span>
        <ul>
          <li :key="d._id" v-for="d in datum.children">
            {{ d.name.nameWithSequence }}
          </li>
        </ul>
      </div>
      <span v-if="mode === 'Confirmation'">
        All related data will be transacted. Are you sure want to submit?
      </span>
    </template>
    <template #footer v-if="mode !== 'Confirmation'">
      <div class="flex items-center justify-end">
        <TSButton
          @click="visible = false"
          data-ts-section="close-button"
          label="Close"
          outlined
        />
      </div>
    </template>
  </TSDialogConfirm>
</template>
